import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { History, ArrowRight } from "lucide-react";
import type { ApplicantStageHistory, ApplicationStage } from "@/types/applicant";
import { stageLabels, stageColors } from "@/types/applicant";

interface ApplicantHistoryProps {
  history: ApplicantStageHistory[];
}

const ApplicantHistory = ({ history }: ApplicantHistoryProps) => {
  if (history.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-muted-foreground">
          Noch keine Verlaufseinträge vorhanden
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <History className="h-5 w-5" />
          Bewerbungsverlauf
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-border" />

          <div className="space-y-6">
            {history.map((entry, index) => (
              <div key={entry.id} className="relative pl-10">
                {/* Timeline dot */}
                <div
                  className={`absolute left-2 top-1 w-5 h-5 rounded-full ${
                    stageColors[entry.to_stage]
                  } flex items-center justify-center`}
                >
                  <div className="w-2 h-2 rounded-full bg-white" />
                </div>

                <div className="bg-muted/50 rounded-lg p-4">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    {entry.from_stage && (
                      <>
                        <span className="text-sm text-muted-foreground">
                          {stageLabels[entry.from_stage]}
                        </span>
                        <ArrowRight className="h-4 w-4 text-muted-foreground" />
                      </>
                    )}
                    <span className="font-medium text-sm">
                      {stageLabels[entry.to_stage]}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
                    <span>
                      {new Date(entry.created_at).toLocaleDateString("de-DE", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    {entry.changed_by && <span>von {entry.changed_by}</span>}
                  </div>

                  {entry.notes && (
                    <p className="mt-2 text-sm text-foreground">{entry.notes}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApplicantHistory;
